import { action, computed, makeObservable, observable } from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import Feature from "../../Feature";
import errorToast from "../../../components/toast/ErrorToast";
import DashboardDateRangeValidity from "../DashboardDateRangeValidity";

const EMPTY_SUMMARY_KPIS = {
    billingFulfillment: null,
    billingFulfillmentVsBudget: null,
    boxesFulfillment: null,
    boxesFulfillmentVsBudget: null,
    elapsedWorkingDays: 0,
    totalWorkingDays: 0,
    daysProgress: null,
};

export default class SummaryKpisFeature extends Feature {
    constructor(application, filters) {
        super(application);
        this._filters = filters;
        this._summaryKpis = EMPTY_SUMMARY_KPIS;

        makeObservable(this, {
            _summaryKpis: observable,
            summaryKpis: computed,
            setSummaryKpis: action,
        });
    }

    async load() {
        if (!DashboardDateRangeValidity.isValid(this._filters.fromDate, this._filters.toDate)) {
            return;
        }
        await this._getSummaryKpis();
        this.finishLoading();
    }

    setSummaryKpis(summaryKpis) {
        this._summaryKpis = summaryKpis;
    }

    get summaryKpis() {
        return this._summaryKpis;
    }

    async _getSummaryKpis() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.setSummaryKpis(response.summaryKpis());
            },
            handlesError: () => {
                errorToast("No se pudieron obtener los indicadores del período");
                this.setSummaryKpis(EMPTY_SUMMARY_KPIS);
            },
        });
        return this._application.apiClient().getSummaryKpis(responseHandler, this._filters.fromDate, this._filters.toDate, this._filters.channels, this._filters.articleCategories);
    }
}
